// extracted by mini-css-extract-plugin
export var reviews = "styles-module--reviews--f3d43";
export var siteReviews = "styles-module--siteReviews--7123e";